import React from 'react';
import './styles.sass';
import assets from '../../assets';
import { useAdminCompetitiveExam } from './handler';
import { Pagination } from '../pagination';

export const AdminCompetitiveExam = () => {
    const {
        studentRequests,
        stats,
        search,
        setSearch,
        selectedExam,
        setSelectedExam,
        selectedStatus,
        setSelectedStatus,
        selectedStudents,
        handleCheckboxChange,
        handleSelectAll,
        approveSelected,
        rejectSelected,
        resubmitSelected,
        approveOne,
        rejectOne,
        resubmitOne,
        clearSelection,
        currentPage,
        setCurrentPage,
        pageSize,
        refreshData,
        totalResults,
        examOptions,
        showDetailModal,
        selectedRequest,
        openDetailModal,
        closeDetailModal,
        loading
    } = useAdminCompetitiveExam();

    const selectedCount = Object.values(selectedStudents).filter(Boolean).length;

    const renderStatCard = (title, count, icon, type) => (
        <section className={`stat_card`}>
            <section className={`stat_icon_outer_wrapper ${type}`}>
                <section className="stat_icon_inner_circle">
                    <img src={icon} alt={title} />
                </section>
            </section>
            <section className="stat_info">
                <h5>{title}</h5>
                <h4>{count.toLocaleString()}</h4>
            </section>
        </section>
    );

    return (
        <section className="admin_competitive_exam_page_wrapper">
            <header className="admin_header">
                <h4>Competitive Exam</h4>
                <section className="notify_wrapper">
                    <img src={assets.ic_notify_bell} alt="notification" />
                </section>
            </header>

            <section className="stats_container">
                {renderStatCard("Total Request", stats.total, assets.ic_school_manage || assets.ic_graudate, "total")}
                {renderStatCard("Pending", stats.pending, assets.ic_timer_blue || assets.ic_time, "pending")}
                {renderStatCard("Approved", stats.accepted, assets.ic_correct_tick || assets.ic_tick_white, "approved")}
                {renderStatCard("Rejected", stats.rejected, assets.ic_close_wrong || assets.ic_wrong_close, "rejected")}
            </section>

            <section className="top_actions_bar">
                <section className="refresh_btn" onClick={refreshData}>
                    <img src={assets.ic_refetch} alt="refresh" />
                    <h5>Refresh</h5>
                </section>
            </section>

            {selectedCount > 0 && (
                <section className="selection_banner">
                    <h4>{selectedCount} student selected</h4>
                    <section className="banner_actions">
                        <button className="resubmit_btn" onClick={resubmitSelected}>
                            <img src={assets.ic_info} alt="resubmit" width="14" />
                            Resubmit
                        </button>
                        <button className="approve_btn" onClick={approveSelected}>
                            <img src={assets.ic_tick_white} alt="approve" />
                            Approve Selected
                        </button>
                        <button className="reject_btn" onClick={rejectSelected}>
                            <img src={assets.ic_close_white} alt="reject" />
                            Reject Selected
                        </button>
                        <section className="close_banner" onClick={clearSelection}>
                            <img src={assets.ic_close} alt="close" />
                        </section>
                    </section>
                </section>
            )}

            <section className="filters_container">
                <section className="search_wrapper">
                    <img src={assets.ic_search} alt="search" />
                    <input 
                        type="text" 
                        placeholder="Search students by name or email..." 
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </section>
                <section className="dropdown_filters">
                    <section className="filter_select_wrapper">
                        <select 
                            value={selectedExam} 
                            onChange={(e) => setSelectedExam(e.target.value)}
                        >
                            <option value="All Exams">All Exams</option>
                            {examOptions.map((exam, index) => (
                                <option key={index} value={exam}>
                                    {exam}
                                </option>
                            ))}
                        </select>
                        <img src={assets.ic_chevron_down} alt="chevron" />
                    </section>
                    <section className="filter_select_wrapper">
                        <select 
                            value={selectedStatus} 
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="All Status">All Status</option>
                            <option value="Pending">Pending</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                        <img src={assets.ic_chevron_down} alt="chevron" />
                    </section>
                </section>
            </section>

            <section className="table_card">
                {loading && (
                    <div className="table_loader_overlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <table className="admin_table">
                    <thead>
                        <tr>
                            <th className="checkbox_cell">
                                <input 
                                    type="checkbox" 
                                    onChange={handleSelectAll}
                                    checked={selectedCount === studentRequests.length && studentRequests.length > 0}
                                />
                            </th>
                            <th>Student Name</th>
                            <th>Exam</th>
                            <th>Request Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studentRequests.map((student) => (
                            <tr key={student.id}>
                                <td className="checkbox_cell">
                                    <input 
                                        type="checkbox" 
                                        checked={!!selectedStudents[student.id]}
                                        onChange={() => handleCheckboxChange(student.id)}
                                    />
                                </td>
                                <td>
                                    <section className="student_profile_cell">
                                        <img src={student.avatar} alt={student.name} className="student_avatar" />
                                        <section className="student_info">
                                            <h4>{student.name}</h4>
                                            <p>{student.email}</p>
                                        </section>
                                    </section>
                                </td>
                                <td>
                                    <span className="exam_name">{student.exam}</span>
                                </td>
                                <td>
                                    <span className="request_date">{student.requestDate}</span>
                                </td>
                                <td>
                                    <span className={`status_badge ${student.status.toLowerCase()}`}>
                                        {student.status}
                                    </span>
                                </td>
                                <td>
                                    <section className="action_icons">
                                                <button 
                                                    className="view_btn"
                                                    onClick={() => openDetailModal(student)}
                                                    title="View Details"
                                                >
                                                    <img src={assets.ic_eye} alt="view" />
                                                </button>
                                        {student.status.toLowerCase() === 'pending' ? (
                                            <>
                                                <button 
                                                    className="approve_btn"
                                                    onClick={() => approveOne(student.id)}
                                                    title="Approve"
                                                >
                                                    <img src={assets.ic_tick_white} alt="approve" />
                                                </button>
                                                <button 
                                                    className="reject_btn"
                                                    onClick={() => rejectOne(student.id)}
                                                    title="Reject"
                                                >
                                                    <img src={assets.ic_close_white} alt="reject" />
                                                </button>
                                            </>
                                        ) : (
                                            <span className="no_actions">---</span>
                                        )}
                                    </section>
                                </td>
                            </tr>
                        ))}
                        {studentRequests.length === 0 && (
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                                    No requests found matching your filters.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <section className="pagination_container">
                    <span className="results_count">
                        Showing {(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalResults)} results
                    </span>
                    <Pagination
                        totalResults={totalResults}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}
                    />
                </section>
            </section>

            {showDetailModal && selectedRequest && (
                <div className="detail_modal_overlay" onClick={closeDetailModal}>
                    <div className="detail_modal_content" onClick={(e) => e.stopPropagation()}>
                        <header className="modal_header">
                            <h3>Payment Verification</h3>
                            <button className="close_modal" onClick={closeDetailModal}>
                                <img src={assets.ic_close} alt="close" />
                            </button>
                        </header>

                        <div className="modal_body">
                            <div className="info_section">
                                <div className="info_grid">
                                    <div className="info_item">
                                        <label>Student Name</label>
                                        <span>{selectedRequest.name}</span>
                                    </div>
                                    <div className="info_item">
                                        <label>Email Address</label>
                                        <span>{selectedRequest.email}</span>
                                    </div>
                                    <div className="info_item">
                                        <label>Exam</label>
                                        <span>{selectedRequest.exam}</span>
                                    </div>
                                    <div className="info_item">
                                        <label>UTR / Reference Number</label>
                                        <span className="utr_text">{selectedRequest.utr_id || 'N/A'}</span>
                                    </div>
                                    <div className="info_item">
                                        <label>Request Date</label>
                                        <span>{selectedRequest.requestDate}</span>
                                    </div>
                                    <div className="info_item">
                                        <label>Current Status</label>
                                        <span className={`status_badge ${selectedRequest.status.toLowerCase()}`}>
                                            {selectedRequest.status}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="screenshot_section">
                                <label>Payment Screenshot</label>
                                <div className="screenshot_wrapper">
                                    {selectedRequest.screenshot_url ? (
                                        <img src={selectedRequest.screenshot_url} alt="Payment Proof" />
                                    ) : (
                                        <div className="no_screenshot">
                                            <img src={assets.ic_info} alt="no info" />
                                            <p>No screenshot provided</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {selectedRequest.status.toLowerCase() === 'pending' && (
                            <footer className="modal_footer">
                                <button className="resubmit_btn" onClick={() => { resubmitOne(selectedRequest.id); closeDetailModal(); }}>
                                    Resubmit Request
                                </button>
                                <button className="reject_btn" onClick={() => { rejectOne(selectedRequest.id); closeDetailModal(); }}>
                                    Reject Request
                                </button>
                                <button className="approve_btn" onClick={() => { approveOne(selectedRequest.id); closeDetailModal(); }}>
                                    Approve Request
                                </button>
                            </footer>
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};
